import React, {useEffect, useState} from 'react'
import FooterContent from './partials/footer-content'
import FooterModal from '../checkout-footer/partials/footer-modal'

import {
    Box,
    useMultiStyleConfig,
    useDisclosure
} from '@salesforce/retail-react-app/app/components/shared/ui'
import useContentAsset from '../../hooks/use-content-asset'
import useAppState from '../../hooks/use-app-state'
import useChatbotLoader from '../../hooks/use-chatbot-loader'

const CheckoutFooter = ({...otherProps}) => {
    const [modalContent, setModalContent] = useState('')
    const [footerContent, setFooterContent] = useState({
        footerReassurance: '',
        footerModal: {}
    })

    const styles = useMultiStyleConfig('CheckoutFooter')
    const {isLoading, data: assetResponse} = useContentAsset('footer')

    useEffect(() => {
        if (!isLoading && assetResponse) {
            setFooterContent(assetResponse)
        }
    }, [isLoading, assetResponse])

    const {footerReassurance, footerModal} = footerContent

    const {
        isOpen: isFooterModalOpen,
        onOpen: onFooterModalOpen,
        onClose: onFooterModalClose
    } = useDisclosure()

    const {
        preferences: {disableEcommerce, enableAlias, liveChatEnvironment}
    } = useAppState()
    useChatbotLoader(disableEcommerce, enableAlias, liveChatEnvironment)

    return (
        <>
            <Box as="footer" {...styles.footer} {...otherProps}>
                <Box {...styles.container}>
                    <FooterContent
                        id="footer-reassurance"
                        content={footerReassurance}
                        styles={styles['footer-reassurance']}
                        setModalContent={setModalContent}
                        onClick={onFooterModalOpen}
                    />
                </Box>

                <FooterModal
                    styles={styles.footerModal}
                    content={footerModal?.[modalContent]}
                    isOpen={isFooterModalOpen}
                    onClose={onFooterModalClose}
                />
            </Box>
        </>
    )
}

export default CheckoutFooter
